import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'shared_DEPRECATED/hooks';

import { SessionMetadataResponse } from 'features/sessions/config/types';

export const useSessionMetadataQuery = () => {
  const { request } = useQueryHTTPRequest();

  return useQuery<SessionMetadataResponse>(
    [queryKeys.coachSessionMetadata],
    ({ signal }) =>
      request({ url: `/api/coach/coaching-sessions/metadata`, signal }),
    {
      useErrorBoundary: false,
      staleTime: Infinity,
    }
  );
};
